import { apiClient } from '@/api/api'
import type { AxiosResponse } from 'axios'
import type { UserParametersResponse, UpdateParameterPayload } from '@/types/parameters'
import type { MeasurementType } from '@/features/survey/types/survey-config'

/**
 * Преобразует measurementType из camelCase в snake_case для использования в URL
 * Примеры: 'footLength' -> 'foot_length', 'shoulderWidth' -> 'shoulder_width'
 */
function measurementTypeToSnakeCase(measurementType: MeasurementType): string {
  return measurementType.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`)
}

/**
 * Получение всех параметров пользователя с метаданными
 * GET /user/parameters
 */
export const getUserParameters = async (): Promise<AxiosResponse<UserParametersResponse>> => {
  return apiClient.get<UserParametersResponse>('/user/parameters')
}

/**
 * Интерфейс ответа при обновлении параметра
 * PATCH /user/parameters/{measurement_type} возвращает этот формат
 */
export interface UpdateParameterResponse {
  success: boolean
  measurementType: MeasurementType
  value: number | null
}

/**
 * Обновление одного параметра
 * PATCH /user/parameters/{measurement_type}
 */
export const updateParameter = async (
  measurementType: MeasurementType,
  payload: UpdateParameterPayload
): Promise<AxiosResponse<UpdateParameterResponse>> => {
  const measurementTypeSnake = measurementTypeToSnakeCase(measurementType)
  return apiClient.patch<UpdateParameterResponse>(
    `/user/parameters/${measurementTypeSnake}`,
    payload
  )
}

/**
 * Сброс всех параметров пользователя
 * DELETE /user/parameters
 */
export const resetParameters = async (): Promise<AxiosResponse<void>> => {
  return apiClient.delete<void>('/user/parameters')
}

